export const showOnHome = (page)=>page.kind == 'home';
export const showOnHomeAndBranch = (page)=>page.kind == 'home' || page.kind == 'locationDetail';
const homeAndActivities = new Set([
    'home',
    'activityClusters',
    'activityDetail'
]);
export const showOnHomeAndActivities = (page)=>homeAndActivities.has(page.kind);
